import AddCustomerSection from "../../StoreCheckout/AddCustomerSection";
import styles from "./styles.module.scss";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import primaryComponents from "../../../primaryComponents";
import { useGetCustomerWallet } from "../../../../hooks/api/queries/useLoyalty";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addLoyaltyPoint } from "../../../../store/modules/checkoutInfo";
import { useValidation } from "./useValidation";
import { ToastContext } from "../../../../hooks/context";
import { useOtpAuthTrigger } from "../../../../hooks/useOtpAuthTrigger";
import { useParams } from "react-router-dom";

export const LoyaltyPoint = ({
  currency_symbol,
  loyaltyType,
  closeModal = () => {},
}) => {
  const { store_id } = useParams();
  const dispatch = useDispatch();
  const triggerToast = useContext(ToastContext);
  const { customer } = useSelector((state) => state?.checkoutReducer);
  const [customerInfo, setCustomerInfo] = useState(customer || {});
  const [amount, setAmount] = useState("");
  const {
    control,
    formState: { errors },
    trigger,
    setValue,
    setError,
    handleSubmit,
  } = useValidation({ loyaltyType });
  const { data: dataCustomerWallet } = useGetCustomerWallet(
    customerInfo?.customer_id,
  );
  const { handleOrderModuleAuth, isLoadingAuthAction } = useOtpAuthTrigger({
    storeId: store_id,
    params: {},
  });

  const setLoyaltyPoint = () => {
    dispatch(
      addLoyaltyPoint({
        customer_id: customerInfo?.customer_id,
        amount,
      }),
    );
  };

  const handleAddLoyaltyPoint = () => {
    if (
      dataCustomerWallet &&
      Number(amount) > Number(dataCustomerWallet.balance_naira_equiv)
    ) {
      return triggerToast(
        "Loyalty point amount is greater than available balance",
        "warning",
      );
    }

    handleOrderModuleAuth({
      actionKey: "add_loyalty_to_order",
      onSuccessCallBack: () => {
        setLoyaltyPoint();
        closeModal();
      },
    });
  };

  useEffect(() => {
    if (customerInfo?.customer_id) {
      setValue("customer_id", customerInfo?.customer_id);
      setError("customer_id", "");
    } else setValue("customer_id", "");
  }, [customerInfo?.customer_id]);

  return (
    <>
      <form
        id="loyaltyForm"
        className={styles.contentContainer}
        onSubmit={handleSubmit(handleAddLoyaltyPoint)}
      >
        <div>
          <AddCustomerSection
            title="Search Existing Customers"
            customerDetails={customerInfo}
            setCustomerDetails={(customerDetails) => {
              setCustomerInfo({
                customer_id: customerDetails?.customerId,
                ...customerDetails,
              });
            }}
            showAddCustomer={false}
            showLoyalty={false}
          />
          {errors?.customer_id?.message && (
            <p className="error-message text-danger">
              <FontAwesomeIcon
                icon={["fas", "exclamation-circle"]}
                className="mr-2"
                style={{ fontSize: "13px" }}
              />
              <span>{errors?.customer_id?.message}</span>
            </p>
          )}
        </div>

        <div
          className={globalStyles.cardWithBackground}
          style={{ background: "rgba(243, 243, 243, 1)" }}
        >
          <h6 className="mb-0">Loyalty Details</h6>
          <div
            className={`${globalStyles.cardWithBorder} white w-100`}
            style={{ borderRadius: 0 }}
          >
            <div className={"text-center"}>
              <p className={`${styles.availableBalance} small-text-size`}>
                Available Balance
              </p>
              <h5 className="text-center mb-0">
                {dataCustomerWallet
                  ? `${currency_symbol} ${dataCustomerWallet?.balance_naira_equiv}`
                  : "-"}
              </h5>
            </div>
          </div>
        </div>

        <primaryComponents.InputFieldV2
          control={control}
          name="amount"
          label={`Amount (${currency_symbol})`}
          classNames="white"
          placeholder="Enter amount to take out of your giftcard balance"
          isRequired={true}
          value={amount}
          type="number"
          min="0"
          floatError={false}
          onChange={({ target: { value } }) => {
            setAmount(value);
          }}
          errorMessage={errors.amount}
          onKeyUp={() => errors.amount !== undefined && trigger("amount")}
        />
      </form>

      <primaryComponents.Button
        classNames={"btn btn--primary"}
        form="loyaltyForm"
        type="submit"
        isLoading={isLoadingAuthAction}
      >
        Apply
      </primaryComponents.Button>
    </>
  );
};
